<template>
    <!-- 删除 -->
    <div class="">
      <v-dialog
        class="del"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.delete"
      >
      确定要删除此策略配置吗？

      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    UseId:{
    },

    },
    data() {
      return {
        delete:"删除",

        isShow:false,
        dialogTitle: "删除",
      };
    },
    created() {

    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      handleConfirm() {

      this.$delete(`/td/td-iot-api/iot/white-list/v1/${this.UseId}`).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
      this.$emit('getData')

      this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
